export default __webpack_public_path__ + "static/media/agromir.5ef3273e.png";